import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  // Auth loading and already-authenticated redirect are handled
  // at the app level (AppRoutes in App.tsx), so this component
  // only renders when loading is false and user is not authenticated.

  const handleSuccess = async (response: CredentialResponse) => {
    setError(null);
    if (!response.credential) {
      setError('No credential received from Google');
      return;
    }

    try {
      await login(response.credential);
      // Navigate to home after successful login (no page reload)
      navigate('/', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    }
  };

  const handleError = () => {
    setError('Google sign-in failed. Please try again.');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Movie Playlists</h1>
        <p>Sign in to browse the movie database</p>

        <div className="login-button-wrapper">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            useOneTap
            theme="filled_black"
            size="large"
            text="signin_with"
            shape="rectangular"
          />
        </div>

        {error && <div className="login-error">{error}</div>}
      </div>
    </div>
  );
}
